import { Component, EventEmitter, Input, Output } from '@angular/core';

/**
 * "New password" + "repeat password" pair with the match check in one place. Used by the self-service
 * password change, the admin user settings and the public reset-password page. The password policy
 * itself is enforced by the API only (422 PasswordPolicyViolation, shown as a toast by HttpService).
 */
@Component({
  selector: 'avs-password-confirm-input',
  templateUrl: './password-confirm-input.component.html',
  styleUrls: ['./password-confirm-input.component.css']
})
export class PasswordConfirmInputComponent {
  @Input() labelNew: string | undefined = 'Neues Passwort';
  @Input() labelConfirm: string | undefined = 'Passwort wiederholen';
  @Input() placeholderNew: string = '';
  @Input() placeholderConfirm: string = '';
  @Input() required: boolean = true;
  @Input() disabled: boolean = false;

  /** Emits the password when both inputs are non-empty and equal, otherwise an empty string. */
  @Output() passwordChange: EventEmitter<string> = new EventEmitter<string>();

  public password: string = '';
  public confirmPassword: string = '';

  /** Clears both inputs, e.g. after a successful save. Called by the parent via @ViewChild. */
  public clear(): void {
    this.password = '';
    this.confirmPassword = '';
    this.emit();
  }

  public get isMismatch(): boolean {
    return this.confirmPassword.length > 0 && this.password !== this.confirmPassword;
  }

  public get isMatch(): boolean {
    return this.password.length > 0 && this.password === this.confirmPassword;
  }

  public onPasswordChange(value: string): void {
    this.password = value;
    this.emit();
  }

  public onConfirmPasswordChange(value: string): void {
    this.confirmPassword = value;
    this.emit();
  }

  private emit(): void {
    this.passwordChange.emit(this.isMatch ? this.password : '');
  }
}
